import axios from 'axios';
import apiUrl from '../../api-url';
import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";
import chainReducers from "../../vendor/signal-utils/chain-reducers";
import Authentication from '../auth/authentication';

import * as OrganizationsActions from '../../modules/organizations/OrganizationsState';
import * as RolesActions from '../../modules/roles/RolesState';

const authentication = new Authentication();

// URLS
const USERS_URL = apiUrl('/iam/users');

// Actions
const SET_CURRENT_USER = 'Users/SET_CURRENT_USER';

const RECEIVE_USERS = 'Users/RECEIVE_USERS';

const ADD_USER = 'Users/ADD_USER';
const ADD_USER_SUCCEEDED = 'Users/ADD_USER_SUCCEEDED';
const ADD_USER_FAILED = 'Users/ADD_USER_FAILED';

const UPDATE_USER = 'Users/UPDATE_USER';
const UPDATE_USER_SUCCEEDED = 'Users/UPDATE_USER_SUCCEEDED';
const UPDATE_USER_FAILED = 'Users/UPDATE_USER_FAILED';

const DELETE_USER = 'Users/DELETE_USER';
const DELETE_USER_SUCCEEDED = 'Users/DELETE_USER_SUCCEEDED';
const DELETE_USER_FAILED = 'Users/DELETE_USER_FAILED';

const duck = buildFetchDuck('users');

// Action creators
export function setCurrentUser(user) {
  return dispatch => {
    return dispatch({type: SET_CURRENT_USER, currentUser: user})
  }
}

export function fetchUsers() {
  const url = `${USERS_URL}`;
  return dispatch => dispatch(duck.fetch(url));
}

export function addUser(payload) {
  return function (dispatch) {
    dispatch({ type: ADD_USER , payload });
    dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(false));
    const url = USERS_URL;
    return axios.post(url, payload)
        .then((resp) => {
            dispatch({ type: ADD_USER_SUCCEEDED });

            const organizationId = sessionStorage.getItem('currentOrganization')
            dispatch(OrganizationsActions.fetchOrganizationMembers(organizationId));
            dispatch(RolesActions.fetchRoles());
        })
        .catch(error => {
          dispatch({ type: ADD_USER_FAILED, error });
          dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(true));
        });
  }
}

export function updateUser(userId, payload) {
  return function(dispatch) {
    dispatch({ type: UPDATE_USER, userId, payload });
    dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(false));
    const url = USERS_URL + `/${userId}`;
    return axios.patch(url, payload)
        .then((resp) => {
            dispatch({ type: UPDATE_USER_SUCCEEDED, userId, payload });
            
            const organizationId = sessionStorage.getItem('currentOrganization')
            dispatch(OrganizationsActions.fetchOrganizationMembers(organizationId));
            dispatch(RolesActions.fetchRoles());       
        })
        .catch(error => {
          dispatch({type: UPDATE_USER_FAILED, userId, error});
          dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(true));
        });
  }
}

export function deleteUser(user) {
  return function(dispatch) {
    const userId = user.user_id;
    const payload = {
      organization_id: user.organization_id
    }

    dispatch({ type: DELETE_USER, userId, payload });
    dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(false));
    const url = USERS_URL + `/${userId}`;
    return axios.delete(url, { data: payload })
    .then((resp) => {
        dispatch({type: DELETE_USER_SUCCEEDED});

        const organizationId = sessionStorage.getItem('currentOrganization')
        dispatch(OrganizationsActions.fetchOrganizationMembers(organizationId));
        dispatch(RolesActions.fetchRoles());
    })
    .catch(error => {
      dispatch({type: DELETE_USER_FAILED, userId, error});
      dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(true));
    });
  }
}

export function blockUser(user) {
  return function(dispatch) {
    const userId = user.user_id;
    const payload = {
      organization_id: user.organization_id
    }
    dispatch({ type: UPDATE_USER, userId, payload });
    dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(false));
    const url = USERS_URL + `/${userId}/block-user`;
    return axios.patch(url, payload)
        .then((resp) => {
            dispatch({ type: UPDATE_USER_SUCCEEDED, userId, payload });

            const organizationId = sessionStorage.getItem('currentOrganization')
            dispatch(OrganizationsActions.fetchOrganizationMembers(organizationId));           
        })
        .catch(error => {
          dispatch({type: UPDATE_USER_FAILED, userId, error})
          dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(true));
        });
  }
} 

export function unblockUser(user) {
  const userId = user.user_id;
  return function(dispatch) {
    const payload = {
      organization_id: user.organization_id
    }
    dispatch({ type: UPDATE_USER, userId, payload });
    dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(false));
    const url = USERS_URL + `/${userId}/unblock-user`;
    return axios.patch(url, payload)
        .then((resp) => {
            dispatch({ type: UPDATE_USER_SUCCEEDED, userId, payload });

            const organizationId = sessionStorage.getItem('currentOrganization')
            dispatch(OrganizationsActions.fetchOrganizationMembers(organizationId));            
        })
        .catch(error => {
          dispatch({type: UPDATE_USER_FAILED, userId, error});
          dispatch(OrganizationsActions.setIsOrganizationMembersLoaded(true));
        });
  }
}

const initialState = {
    auth: authentication,
    data: []
};

function UsersReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.currentUser
      };
    case RECEIVE_USERS:  
      return {
          ...state,
          data: action.payload
      };  
    default:
      return state
  }
}

export default chainReducers([UsersReducer, duck.reducer]);




// WEBPACK FOOTER //
// ./src/modules/users/UsersState.js